import { useState, useEffect } from 'react';
import { buildApiUrl } from '../utils/apiConfig';
import { jsonGet } from '../utils/http';
import { ComboBoxOption } from '../polaris-components/ComboBox';

type ApiMember = {
    id?: number;
    adminId?: number;
    name: string;
    roleName: string;
    viewTeamHref?: string;
};

type ApiResponse = {
    companyMemberCards?: ApiMember[];
};

const STAFF_ADMIN_ROLES = ['staff', 'admin', 'administrator', 'coach'];

export function useStaffMembers(): { staffMembers: ComboBoxOption[]; loading: boolean } {
    const [staffMembers, setStaffMembers] = useState<ComboBoxOption[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const res = await jsonGet<ApiResponse>(buildApiUrl('api/company/members'), true);
                const members = res?.companyMemberCards ?? [];

                const staffAndAdmins = members
                    .filter(m => {
                        const role = m.roleName?.toLowerCase() ?? '';
                        return STAFF_ADMIN_ROLES.some(r => role.includes(r));
                    })
                    .reduce<ComboBoxOption[]>((acc, m) => {
                        // API returns id in viewTeamHref (e.g. "/team/view/1005")
                        // id and adminId are not present in this endpoint's response
                        const hrefSegment = m.viewTeamHref?.split('/').pop();
                        const id = (hrefSegment ? parseInt(hrefSegment, 10) : NaN)
                            || m.id
                            || m.adminId;
                        if (id != null && !isNaN(id) && id > 0) {
                            acc.push({ id, name: m.name });
                        }
                        return acc;
                    }, []);

                setStaffMembers(staffAndAdmins);
            } catch {
                setStaffMembers([]);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    return { staffMembers, loading };
}

